import React, { useEffect } from "react";
import Image from "next/image";
import { AppConstants } from "@/app/lib/util/AppConstants";
import { AnalyticsEventParams } from "@/app/lib/models/AnalyticsEventParams";
import KovaadAnalytics from "@/app/lib/analytics/KovaadAnalytics";
import { useRouter } from "next/navigation";

interface LoginFormProps {
  isSigningIn: boolean;
  onGoogleSignIn: (e: any) => void;
  onMicrosoftSignIn: (e: any) => void;
}

const LoginForm: React.FC<LoginFormProps> = ({
  isSigningIn,
  onGoogleSignIn,
  onMicrosoftSignIn,
}: LoginFormProps) => {
  const router = useRouter();
  useEffect(() => {
    const eventParams: AnalyticsEventParams = {
      page: AppConstants.ViewsName.LOGIN,
      eventType: "Loaded",
      role: "guest",
    };
    KovaadAnalytics.logEvent(AppConstants.ViewsName.LOGIN, eventParams);
  }, []);

  return (
    <main className="flex justify-center items-center min-h-44 p-2 ">
      <div className="text-lg text-left w-full max-w-md grid grid-cols-1 ">
        <form method="POST">
          <button
            disabled={isSigningIn}
            onClick={(e) => {
              onGoogleSignIn(e);
            }}
            className={`w-64 flex mx-auto items-center whitespace-nowrap  overflow-auto justify-center gap-x-3 py-2.5 px-2 border rounded-lg small-body-font-size ${isSigningIn ? "cursor-not-allowed" : "hover:bg-color-white transition duration-300"}`}
          >
            <Image
              src="/google-logo.svg"
              width={25}
              height={25}
              alt="Google Login"
            />
            {isSigningIn ? "Signing In..." : "Continue with Google"}
          </button>
          <button
            disabled={isSigningIn}
            onClick={(e) => {
              onMicrosoftSignIn(e);
            }}
            className={`w-64 flex m-2 mx-auto items-center whitespace-nowrap overflow-auto justify-center gap-x-3 py-2.5 px-2 border rounded-lg small-body-font-size ${isSigningIn ? "cursor-not-allowed" : "hover:bg-color-white transition duration-300 active:bg-color-white"}`}
          >
            <Image
              src="/microsoft-logo.svg"
              width={25}
              height={25}
              alt="Microsoft Login"
            />
            {isSigningIn ? "Signing In..." : "Continue with Microsoft"}
          </button>

          {/*<div className="mx-auto mt-10 text-color-gray text-xs text-center">
                        Don&apos;t have an account?{" "}
                        <Link href={AppConstants.RouteUrls.REGISTER} className="font-bold text-color-primary"
                              onClick={(e) => {
                                  e.preventDefault();
                                  goToPage(router, AppConstants.RouteUrls.REGISTER);
                              }}>
                            Sign up.
                        </Link>
                    </div>*/}
        </form>
      </div>
    </main>
  );
};

export default LoginForm;
